import getOptimisedImagesUrl, { formatSizes, getSrcSetUrls } from './getOptimisedImagesUrl.js'
import groupByType from './groupByType.js'
import { GATE_SIZES, GATE_SRC_SETS } from './constants.js'

export default function preloadPostMedia(post) {
  if (!post || !post.rawMedia) return
  if (post.isTikTokPost || post.isYoutubePost) return

  const urlsTypeMedia = groupByType(post.rawMedia, 'type')
  const urlsImages = urlsTypeMedia?.image?.map((media) => media.url)
  const urlVideos = urlsTypeMedia?.video?.map((media) => media.url)

  if (urlsImages?.length) {
    for (const urlImage of urlsImages) {
      const img = new Image()
      img.id = urlImage
      img.sizes = formatSizes(GATE_SIZES)
      img.srcset = getSrcSetUrls(urlImage, GATE_SRC_SETS)
      img.src = getOptimisedImagesUrl(urlImage, 640)
      img.decoding = 'auto'
      img.loading = 'eager'
    }
  }
  if (urlVideos?.length) {
    for (const urlVideo of urlVideos) {
      const video = document.createElement('video')
      video.autoplay = true
      video.controls = true
      video.height = 'auto'
      video.loop = true
      video.muted = true
      video.playsInline = true
      video.src = urlVideo
      video.width = '100%'
    }
  }
}
